import { Button, Modal, Pagination, Table, Tag, Tooltip } from "antd";
import React, { useState } from "react";
import {
  ExpandOutlined,
  CompressOutlined,
  CloseOutlined,
  FormOutlined,
} from "@ant-design/icons";
import useCommonListing from "../customHooks/useCommonListing";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { ModuleColor } from "../../icons/ApplicationColor";
import { GetFormattedDateTime } from "../../utils/DateTimeUtils";
import CommonTopDetails from "../CommonTopDetails";
import axiosInstance from "../../../api/Axios";
const SubscriptionAdd = ({
  open,
  onClose,

  course_id,
  LoadAPI,
  callMain,
  from = "course",
  course_ids = [],
  bundle_id = null,
  showMessage = false,
}) => {
  const [fullscreen, setFullscreen] = useState(false);
  const handleClose = () => {
    setFullscreen(false);
    setSelectedRowData([]);
    setSelectedRowKeys([]);

    onClose();
  };
  const userInfo = useSelector((state) => state.user);
  const { id } = useParams();
  console.log(id);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const [selectedRowData, setSelectedRowData] = useState([]);
  const [buttonLoading, setButtonLoading] = useState(false);
  const rowSelection = {
    type: "radio",
    selectedRowKeys,
    onChange: (selectedKeys) => {
      setSelectedRowKeys(selectedKeys);
    },
    onSelect: (record) => {
      setSelectedRowData(record);
    },
  };
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const submitData = async () => {
    setButtonLoading(true);

    console.log(selectedRowKeys, selectedRowData);
    try {
      await axiosInstance.post(
        "customer/customersubscriptions/",
        {
          application: selectedRowData?.application_id,
          application_name: selectedRowData?.application,
          end_date: selectedRowData?.end_date,
          start_date: selectedRowData?.start_date,
          organization: Number(id),
        },
        {
          headers: {
            "X-CSRFToken": csrfToken,
          },
        }
      );
      // message.success("Bulk assignment successful!");
    } catch (error) {
      // message.error("Bulk assignment failed. Please try again.");
    } finally {
      setButtonLoading(false);
      handleClose();
      LoadAPI();
      callMain();
    }
  };
  const {
    data,
    itemsLength,
    loading,
    filterData,
    onShowSizeChange,
    onPageChange,
    handleSearchChange,
    // setFilterData,
    // handleSwitchChange,
    // handleClearAll,
    // setFilterUrl,
  } = useCommonListing({
    passSize: 10,
    passPage: 1,
    passURL: `/customer/customersubscriptionslist/?organization_id=${userInfo?.data?.organization?.id}&customer_id=${id}`,
    loadAgain: open,
    includeStatus: false,
    takeFromData: (res) => res?.data?.data,
    takeCountFrom: (res) => res?.data?.length,
  });
  console.log(data);
  // eslint-disable-next-line no-unused-vars
  const { pageSize, currentPage, active, filter_url } = filterData;
  const columns = [
    {
      title: "Modules",
      dataIndex: "application",
      key: "application",
      align: "center",
      render: (application) => {
        return (
          <Tag
            color={ModuleColor(application)}
            style={{
              maxWidth: "18rem",
              paddingInline: "1rem",
              whiteSpace: "normal",
              wordBreak: "break-word",
            }}
          >
            <span
              className="tag-container"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                // Remove lineHeight so wrapping works
              }}
            >
              {application}
            </span>
          </Tag>
        );
      },
    },
    {
      title: "Contract ID",
      dataIndex: "contract_id",
      key: "contract_id",
    },
    // {
    //   title: "ENROLLMENT TYPE",
    //   dataIndex: "enrollment_type",
    //   key: "enrollment_type",
    // },
    {
      title: "Billing",
      dataIndex: "billing_cycle",
      key: "billing",
    },

    {
      title: "Category",
      dataIndex: "subscription_category",
      key: "subscription_category",
    },

    {
      title: "Start Date",
      dataIndex: "start_date",
      key: "start_date",
      editable: true,
      render: GetFormattedDateTime,
    },
    {
      title: "End Date",
      dataIndex: "end_date",
      key: "end_date",
      editable: true,
      render: GetFormattedDateTime,
    },
    // {
    //   title: "PRODUCTS",
    //   dataIndex: "products",
    //   key: "products",
    //   render: (applications) => (
    //     <span>
    //       {applications.map((tag, index) => {
    //         let color;

    //         if (tag.name === "CO") {
    //           color = "orange";
    //         } else if (tag.name === "JDV2") {
    //           color = "blue";
    //         } else {
    //           color = "red";
    //         }
    //         return (
    //           <Tag
    //             color={color}
    //             key={index}
    //             title={tag.description}
    //             style={{ cursor: "pointer" }}
    //           >
    //             <span style={{ color: "black", fontWeight: "500" }}>
    //               {tag.name}
    //             </span>
    //           </Tag>
    //         );
    //       })}
    //     </span>
    //   ),
    // },
    // {
    //   title: "Active",
    //   dataIndex: "status",
    //   key: "status",
    //   render: renderStatus,
    // },
  ];
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      title={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <span style={{ fontWeight: 600, fontSize: 18 }}>
            Add Subscriptions
          </span>
        </div>
      }
      width={fullscreen ? "100vw" : 1300}
      style={fullscreen ? { top: 0, padding: 0, height: "100vh" } : {}}
      styles={{
        body: fullscreen
          ? { height: "calc(100vh - 100px)", overflow: "auto", padding: 0 }
          : { maxHeight: 800, overflow: "auto", padding: 0 },
      }}
      closeIcon={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 16,
            marginRight: 40,
          }}
        >
          <Tooltip title={fullscreen ? "Exit Fullscreen" : "Expand"}>
            <span
              style={{
                cursor: "pointer",
                fontSize: 20,
                color: "#555",
                borderRadius: "50%",
                padding: 4,
                transition: "background 0.2s, color 0.2s",
                background: fullscreen ? "#f0f0f0" : "transparent",
                boxShadow: fullscreen ? "0 0 4px #ccc" : "none",
                display: "flex",
                alignItems: "center",
              }}
              onClick={(e) => {
                e.stopPropagation();
                setFullscreen((prev) => !prev);
              }}
            >
              {fullscreen ? <CompressOutlined /> : <ExpandOutlined />}
            </span>
          </Tooltip>
          <Tooltip title="Close">
            <span
              style={{
                cursor: "pointer",
                fontSize: 20,
                color: "#555",
                borderRadius: "50%",
                padding: 4,
                transition: "background 0.2s, color 0.2s",
                background: "#f0f0f0",
                boxShadow: "0 0 4px #ccc",
                display: "flex",
                alignItems: "center",
              }}
              onClick={(e) => {
                e.stopPropagation();
                handleClose();
              }}
            >
              <CloseOutlined />
            </span>
          </Tooltip>
        </div>
      }
    >
      <CommonTopDetails
        title={`Client Subscriptions`}
        titleSuffix={`${itemsLength || 0} module(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        showAddButton={false}
        filterAction={false}
        marginPass="15px"
        paddingInlinepass="10px"
        topSizeAdd="5px"
        addButtonProps={{
          modalType: "PopUP",
          modalProps: () => {},
        }}
      />
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        size="small"
        loading={loading}
        className="table-container"
        style={{ margin: "1rem" }}
        pagination={false}
        scroll={{
          x: 400,
        }}
        bordered
        rowSelection={rowSelection}
      />

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "1rem",
        }}
      >
        <Pagination
          size="small"
          showSizeChanger
          onShowSizeChange={onShowSizeChange}
          onChange={onPageChange}
          pageSizeOptions={["5", "10", "15", "20", "50"]}
          //   showQuickJumper
          current={currentPage}
          defaultPageSize={pageSize}
          total={itemsLength}
        />
      </div>
      <div style={{ marginTop: 22 }}>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            margin: "3rem",
            marginInline: "2rem",
            marginBottom: "1rem",
          }}
        >
          <Button
            key="back"
            onClick={(e) => {
              e.stopPropagation();
              handleClose();
            }}
            style={{ marginRight: "1rem" }}
          >
            <CloseOutlined />
            Cancel
          </Button>

          <Button
            type="primary"
            htmlType="submit"
            onClick={submitData}
            loading={buttonLoading}
            disabled={selectedRowKeys.length === 0}
          >
            Save Assignment{selectedRowKeys.length > 1 ? "s" : ""}
            <FormOutlined />
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default SubscriptionAdd;
